import { useIntl } from 'react-intl';
import { MUSIC24_TRIAL_LEVEL_TIER } from 'fym-shared/src/music24/music24Plans';
import { planNameMessages } from '../config/music24PlanNames';

/** The name of the plan the trial gives, from the plan table (never typed into the copy). */
export function useTrialPlanName(): string {
  const intl = useIntl();
  return intl.formatMessage(planNameMessages[MUSIC24_TRIAL_LEVEL_TIER]);
}
